module.exports = __webpack_public_path__ + "img/orange_039.8b72b351.png";